
import { PuttSituation } from "@/types/golf";

export const wedging50m: PuttSituation = {
  id: 10,
  name: "Wedging 50m",
  image: "/lovable-uploads/4f4c4ecd-6e05-4d61-9faa-2f8d181cee61.png",
  description: "Sur le green d'approche ou sur le parcours choisissez un trou et matérialisez la position de départ de cette situation de jeu. Placer une marque au point D=50m disposée entre le bord du green et un trou à 15 m minimum du bord de green. Jouez ensuite 10 balles.",
  distances: [
    { point: "D", distance: 50, ballCount: 10 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 4 },
    { condition: "Balle à moins de 1m", points: 2 },
    { condition: "Balle entre 1m et 2m", points: 1 },
    { condition: "Balle au-delà de 2m", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 39 },
    { points: 1, index: 34 },
    { points: 2, index: 29 },
    { points: 3, index: 25 },
    { points: 4, index: 21 },
    { points: 5, index: 17 },
    { points: 6, index: 13 },
    { points: 7, index: 10 },
    { points: 8, index: 7 },
    { points: 9, index: 5 },
    { points: 10, index: 3 },
    { points: 11, index: 0 },
    { points: 12, index: -2 },
    { points: 13, index: -4 },
    { points: 14, index: -5 },
    { points: 15, index: -6 },
    { points: 16, index: -7 },
    { points: 17, index: -8 },
  ],
};
